export enum VALUE_TYPE {
  TEXT,
  SELECT,
  DATE,
  MONTH,
}

export enum CONDITION_TYPE {
  INCLUDE_3,
  INCLUDE_2,
  INCLUDE_2_1,
  IN_OR_NOT_IN,
  DATE,
  EQUAL,
  EQUAL_OR_NOT_QUAL,
  MATH,
  MIXED,
}

export enum KEY_TYPE {
  CUSTOMER_NUMBER = 'CUSTOMER_NUMBER',
  CUSTOMER_MANAGEMENT_NUMBER = 'CUSTOMER_MANAGEMENT_NUMBER',
  ORGANIZATION_NAME = 'ORGANIZATION_NAME',
  ORGANIZATION_UNDER = 'ORGANIZATION_UNDER',
  CUSTOMER_STAFF_NAME = 'CUSTOMER_STAFF_NAME',
  CUSTOMER_CREATE_DATE = 'CUSTOMER_CREATE_DATE',
  CUSTOMER_UPDATE_DATE = 'CUSTOMER_UPDATE_DATE',
  CUSTOMER_LAST_NAME = 'CUSTOMER_LAST_NAME',
  CUSTOMER_FIRST_NAME = 'CUSTOMER_FIRST_NAME',
  CUSTOMER_LAST_NAME_KANA = 'CUSTOMER_LAST_NAME_KANA',
  CUSTOMER_FIRST_NAME_KANA = 'CUSTOMER_FIRST_NAME_KANA',
  CUSTOMER_BIRTH_DATE = 'CUSTOMER_BIRTH_DATE',
  CUSTOMER_BIRTH_MONTH = 'CUSTOMER_BIRTH_MONTH',
  CUSTOMER_GENDER_CODE = 'CUSTOMER_GENDER_CODE',
  CUSTOMER_JOB_CODE = 'CUSTOMER_JOB_CODE',
  CUSTOMER_PHONE_NUMBER = 'CUSTOMER_PHONE_NUMBER',
  CUSTOMER_CONTACT_PHONE_NUMBER = 'CUSTOMER_CONTACT_PHONE_NUMBER',
  CUSTOMER_MAIL_ADDRESS = 'CUSTOMER_MAIL_ADDRESS',
  CUSTOMER_POSTAL_CODE = 'CUSTOMER_POSTAL_CODE',
  CUSTOMER_ADDRESS = 'CUSTOMER_ADDRESS',
  CUSTOMER_PREFECTURE_CODE = 'CUSTOMER_PREFECTURE_CODE',
  CUSTOMER_SENDABLE_DM = 'CUSTOMER_SENDABLE_DM',
  REVERBERATION_INFO_FIRST_VISIT_DATE = 'REVERBERATION_INFO_FIRST_VISIT_DATE',
  REVERBERATION_INFO_LAST_VISIT_DATE = 'REVERBERATION_INFO_LAST_VISIT_DATE',
  REVERBERATION_INFO_FIRST_PERSON_STAFF_ID = 'REVERBERATION_INFO_FIRST_PERSON_STAFF_ID',
  REVERBERATION_INFO_EX_01_ID = 'REVERBERATION_INFO_EX_01_ID',
  REVERBERATION_INFO_EX_02_ID = 'REVERBERATION_INFO_EX_02_ID',
  REVERBERATION_INFO_PROPOSITION_COURSE = 'REVERBERATION_INFO_PROPOSITION_COURSE',
  REVERBERATION_INFO_REASON_NOTE = 'REVERBERATION_INFO_REASON_NOTE',
  REVERBERATION_INFO_CONTRACT_FLAT_RATE_FLAG = 'REVERBERATION_INFO_CONTRACT_FLAT_RATE_FLAG',
  REVERBERATION_INFO_REVERBERATION_DATE = 'REVERBERATION_INFO_REVERBERATION_DATE',
  MEDIA_NAME = 'MEDIA_NAME',
  DESIRED_COURSE_NAME = 'DESIRED_COURSE_NAME',
  ACCOUNTING_DATE = 'ACCOUNTING_DATE',
  ITEM_BUY = 'ITEM_BUY',
  COURSE_NAME = 'COURSE_NAME',
  TOTAL_NUM = 'TOTAL_NUM',
  ACCOUNTING_AMOUNT='ACCOUNTING_AMOUNT',
  CUSTOMER_STATUS_NAME = 'CUSTOMER_STATUS_NAME',
}

export enum OPERATOR_TYPE {
  LIKE = 'LIKE',
  NOT_LIKE = 'NOT_LIKE',
  GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
  SMALLER_OR_EQUAL = 'SMALLER_OR_EQUAL',
  GREATER = 'GREATER',
  SMALLER = 'SMALLER',
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}

export enum OPERATOR_LABEL_TYPE {
  LIKE = '含む',
  NOT_LIKE = '含まない',
  GREATER_OR_EQUAL = '以上',
  SMALLER_OR_EQUAL = '以下',
  GREATER = '超過',
  SMALLER = '未満',
  EQUAL = '一致する',
  NOT_EQUAL = '一致しない',
}

export enum OPERATOR_LABEL_TYPE2 {
  GREATER_OR_EQUAL = '以上',
  SMALLER_OR_EQUAL = '以下',
  GREATER = '超過',
  SMALLER = '未満',
  EQUAL = '等しい',
}

export enum OPERATOR_DATE_LABEL_TYPE {
  GREATER = '日付より後',
  SMALLER = '日付より前',
  EQUAL = '一致する',
  GREATER_OR_EQUAL = '日付以降',
  SMALLER_OR_EQUAL = '日付以前',

}

export enum SEARCH_TYPE {
  AND = 'AND',
  OR = 'OR'
}

export const operatorOptions = new Map<CONDITION_TYPE, { label: OPERATOR_LABEL_TYPE | OPERATOR_LABEL_TYPE2 | OPERATOR_DATE_LABEL_TYPE, value: OPERATOR_TYPE }[]>([
  [
    CONDITION_TYPE.INCLUDE_3, [
      { label: OPERATOR_LABEL_TYPE.LIKE, value: OPERATOR_TYPE.LIKE },
      { label: OPERATOR_LABEL_TYPE.NOT_LIKE, value: OPERATOR_TYPE.NOT_LIKE },
      { label: OPERATOR_LABEL_TYPE.EQUAL, value: OPERATOR_TYPE.EQUAL },
    ],
  ], // include, not-include, match
  [
    CONDITION_TYPE.INCLUDE_2, [
      { label: OPERATOR_LABEL_TYPE.LIKE, value: OPERATOR_TYPE.LIKE },
      { label: OPERATOR_LABEL_TYPE.NOT_LIKE, value: OPERATOR_TYPE.NOT_LIKE },
    ],
  ], // include, not-include
  [
    CONDITION_TYPE.INCLUDE_2_1, [
      { label: OPERATOR_LABEL_TYPE.LIKE, value: OPERATOR_TYPE.EQUAL },
      { label: OPERATOR_LABEL_TYPE.NOT_LIKE, value: OPERATOR_TYPE.NOT_EQUAL },
    ],
  ], // equal
  [
    CONDITION_TYPE.DATE, [
      { label: OPERATOR_DATE_LABEL_TYPE.GREATER, value: OPERATOR_TYPE.GREATER },
      { label: OPERATOR_DATE_LABEL_TYPE.SMALLER, value: OPERATOR_TYPE.SMALLER },
      { label: OPERATOR_DATE_LABEL_TYPE.EQUAL, value: OPERATOR_TYPE.EQUAL },
      { label: OPERATOR_DATE_LABEL_TYPE.GREATER_OR_EQUAL, value: OPERATOR_TYPE.GREATER_OR_EQUAL },
      { label: OPERATOR_DATE_LABEL_TYPE.SMALLER_OR_EQUAL, value: OPERATOR_TYPE.SMALLER_OR_EQUAL },
    ],
  ], // date
  [
    CONDITION_TYPE.EQUAL, [
      { label: OPERATOR_LABEL_TYPE.EQUAL, value: OPERATOR_TYPE.EQUAL },
    ],
  ], // equal
  [
    CONDITION_TYPE.EQUAL_OR_NOT_QUAL, [
      { label: OPERATOR_LABEL_TYPE.EQUAL, value: OPERATOR_TYPE.EQUAL },
      { label: OPERATOR_LABEL_TYPE.NOT_EQUAL, value: OPERATOR_TYPE.NOT_EQUAL },
    ],
  ], // equal
  [
    CONDITION_TYPE.MATH, [
      { label: OPERATOR_LABEL_TYPE2.GREATER_OR_EQUAL, value: OPERATOR_TYPE.GREATER_OR_EQUAL },
      { label: OPERATOR_LABEL_TYPE2.SMALLER_OR_EQUAL, value: OPERATOR_TYPE.SMALLER_OR_EQUAL },
      { label: OPERATOR_LABEL_TYPE2.GREATER, value: OPERATOR_TYPE.GREATER },
      { label: OPERATOR_LABEL_TYPE2.SMALLER, value: OPERATOR_TYPE.SMALLER },
      { label: OPERATOR_LABEL_TYPE2.EQUAL, value: OPERATOR_TYPE.EQUAL },
    ],
  ], // trở lên, trở xuống, vượt quá, chưa đến, bằng
  [
    CONDITION_TYPE.IN_OR_NOT_IN, [
      { label: OPERATOR_LABEL_TYPE.LIKE, value: OPERATOR_TYPE.IN },
      { label: OPERATOR_LABEL_TYPE.NOT_LIKE, value: OPERATOR_TYPE.NOT_IN },
    ],
  ], // IN và Not In
]);

export type OptionType = {
  label: string,
  value: string,
  orgId?: string,
  path?: string
}

export const valueMenuItemOptions = new Map<KEY_TYPE, OptionType[]>([
  [KEY_TYPE.REVERBERATION_INFO_FIRST_PERSON_STAFF_ID, []],
  [KEY_TYPE.MEDIA_NAME, []],
  [KEY_TYPE.DESIRED_COURSE_NAME, []],
  [KEY_TYPE.ITEM_BUY, []],
  [KEY_TYPE.COURSE_NAME, []],
  [KEY_TYPE.ORGANIZATION_NAME, []],
  [KEY_TYPE.CUSTOMER_GENDER_CODE, [
    { label: '---------', value: 'null' },
    { label: '女性', value: '0' },
    { label: '男性', value: '1' }],
  ],
  [KEY_TYPE.CUSTOMER_JOB_CODE, [
    { label: '---------', value: 'null' },
    { label: '経営者', value: '6' },
    { label: '役員', value: '7' },
    { label: '会社員', value: '8' },
    { label: '契約社員', value: '9' },
    { label: '派遣社員', value: '10' },
    { label: 'パート', value: '11' },
    { label: 'アルバイト', value: '12' },
    { label: '公務員（教職員除く）', value: '13' },
    { label: '教職員', value: '14' },
    { label: '医師', value: '15' },
    { label: '看護師', value: '16' },
    { label: '介護師', value: '17' },
    { label: '自営業', value: '3' },
    { label: '自由業', value: '18' },
    { label: '公認会計士', value: '19' },
    { label: '弁護士', value: '20' },
    { label: '税理士', value: '21' },
    { label: '司法書士', value: '22' },
    { label: '学生', value: '0' },
    { label: 'その他', value: '5' },
  ]],
  [KEY_TYPE.CUSTOMER_CONTACT_PHONE_NUMBER, [
    { label: '可', value: 'true' },
    { label: '不可', value: 'false' },
  ]],
  [KEY_TYPE.CUSTOMER_PREFECTURE_CODE, [
    { label: '---------', value: 'null' },
    { label: '北海道', value: '0' },
    { label: '青森県', value: '1' },
    { label: '岩手県', value: '2' },
    { label: '宮城県', value: '3' },
    { label: '秋田県', value: '4' },
    { label: '山形県', value: '5' },
    { label: '福島県', value: '6' },
    { label: '茨城県', value: '7' },
    { label: '栃木県', value: '8' },
    { label: '群馬県', value: '9' },
    { label: '埼玉県', value: '10' },
    { label: '千葉県', value: '11' },
    { label: '東京都', value: '12' },
    { label: '神奈川県', value: '13' },
    { label: '新潟県', value: '14' },
    { label: '富山県', value: '15' },
    { label: '石川県', value: '16' },
    { label: '福井県', value: '17' },
    { label: '山梨県', value: '18' },
    { label: '長野県', value: '19' },
    { label: '岐阜県', value: '20' },
    { label: '静岡県', value: '21' },
    { label: '愛知県', value: '22' },
    { label: '三重県', value: '23' },
    { label: '滋賀県', value: '24' },
    { label: '京都府', value: '25' },
    { label: '大阪府', value: '26' },
    { label: '兵庫県', value: '27' },
    { label: '奈良県', value: '28' },
    { label: '和歌山県', value: '29' },
    { label: '鳥取県', value: '30' },
    { label: '島根県', value: '31' },
    { label: '岡山県', value: '32' },
    { label: '広島県', value: '33' },
    { label: '山口県', value: '34' },
    { label: '徳島県', value: '35' },
    { label: '香川県', value: '36' },
    { label: '愛媛県', value: '37' },
    { label: '高知県', value: '38' },
    { label: '福岡県', value: '39' },
    { label: '佐賀県', value: '40' },
    { label: '長崎県', value: '41' },
    { label: '熊本県', value: '42' },
    { label: '大分県', value: '43' },
    { label: '宮崎県', value: '44' },
    { label: '鹿児島県', value: '45' },
    { label: '沖縄県', value: '46' }]],
  [KEY_TYPE.CUSTOMER_SENDABLE_DM, [{ label: '---------', value: 'null' }, { label: '可', value: 'true' }, { label: '不可', value: 'false' }]],
  [KEY_TYPE.CUSTOMER_STATUS_NAME, []],
  [KEY_TYPE.REVERBERATION_INFO_EX_01_ID, []],
  [KEY_TYPE.REVERBERATION_INFO_EX_02_ID, []],
  [KEY_TYPE.REVERBERATION_INFO_PROPOSITION_COURSE, []],
  [KEY_TYPE.REVERBERATION_INFO_REASON_NOTE, []],
  [KEY_TYPE.REVERBERATION_INFO_CONTRACT_FLAT_RATE_FLAG, [
    { label: '有', value: 'true' },
    { label: '無', value: 'false' },
  ]],
]);

export const keyOptionsMap = new Map([
  [
    KEY_TYPE.CUSTOMER_NUMBER, {
      label: '顧客番号',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_MANAGEMENT_NUMBER, {
      label: '管理番号',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.ORGANIZATION_NAME,
    {
      label: '店舗',
      operatorType: CONDITION_TYPE.INCLUDE_2,
      valueType: VALUE_TYPE.SELECT, // Org API
      defaultOfValueType: 'null',
      appliesToSubOrganization: false,
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_STAFF_NAME, {
      label: '担当者',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_CREATE_DATE, {
      label: '登録日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_UPDATE_DATE, {
      label: '更新日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_LAST_NAME, {
      label: '顧客姓',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_FIRST_NAME, {
      label: '顧客名',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_LAST_NAME_KANA, {
      label: '顧客姓かな',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_FIRST_NAME_KANA, {
      label: '顧客名かな',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_BIRTH_DATE, {
      label: '生年月日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_BIRTH_MONTH, {
      label: '誕生月',
      operatorType: CONDITION_TYPE.INCLUDE_2_1,
      valueType: VALUE_TYPE.MONTH,
      defaultOfValueType: String(new Date().getMonth() + 1),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2_1)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_GENDER_CODE, {
      label: '性別',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT, // 固定文字列（0:女性 1:男性）
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_JOB_CODE, {
      label: '職業',
      operatorType: CONDITION_TYPE.IN_OR_NOT_IN,
      valueType: VALUE_TYPE.SELECT, // customer_job（0:学生 1:勤務 2:主婦 3:自営 4:無職 5:その他・・・）
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.IN_OR_NOT_IN)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_PHONE_NUMBER, {
      label: '電話番号',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_CONTACT_PHONE_NUMBER, {
      label: 'メール連絡',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT, // 可／不可
      defaultOfValueType: 'true',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_MAIL_ADDRESS, {
      label: 'メールアドレス',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_POSTAL_CODE, {
      label: '郵便番号',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_ADDRESS, {
      label: '住所',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_PREFECTURE_CODE, {
      label: '都道府県',
      operatorType: CONDITION_TYPE.EQUAL_OR_NOT_QUAL,
      valueType: VALUE_TYPE.SELECT, // 固定文字列（0:北海道 1:青森県 2:岩手県 3:宮城県 4:秋田県 5:山形県 6:福島県 7:茨城県 8:栃木県 9:群馬県 10:埼玉県 11:千葉県 12:東京都 13:神奈川県 14:新潟県 15:富山県 16:石川県 17:福井県 18:山梨県 19:長野県 20:岐阜県 21:静岡県 22:愛知県 23:三重県 24:滋賀県 25:京都府 26:大阪府 27:兵庫県 28:奈良県 29:和歌山県 30:鳥取県 31:島根県 32:岡山県 33:広島県 34:山口県 35:徳島県 36:香川県 37:愛媛県 38:高知県 39:福岡県 40:佐賀県 41:長崎県 42:熊本県 43:大分県 44:宮崎県 45:鹿児島県 46:沖縄県）
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL_OR_NOT_QUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_SENDABLE_DM, {
      label: 'DM送信',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT, // 可／不可
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_REVERBERATION_DATE, {
      label: '反響登録日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_FIRST_VISIT_DATE, {
      label: '初回来店日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_LAST_VISIT_DATE, {
      label: '最終来店日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_FIRST_PERSON_STAFF_ID, {
      label: '初回担当者',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.CUSTOMER_STATUS_NAME, {
      label: '会員ステータス',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.MEDIA_NAME, {
      label: '媒体名',
      operatorType: CONDITION_TYPE.INCLUDE_2,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2)?.[0].value,
    },
  ],
  [
    KEY_TYPE.DESIRED_COURSE_NAME, {
      label: '希望のコース名',
      operatorType: CONDITION_TYPE.INCLUDE_2,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_EX_01_ID, {
      label: '悩み・要望',
      operatorType: CONDITION_TYPE.EQUAL_OR_NOT_QUAL,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL_OR_NOT_QUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_PROPOSITION_COURSE, {
      label: '提案コース',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_EX_02_ID, {
      label: '未入会理由',
      operatorType: CONDITION_TYPE.EQUAL_OR_NOT_QUAL,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL_OR_NOT_QUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_REASON_NOTE, {
      label: '入会・未入会理由の詳細',
      operatorType: CONDITION_TYPE.INCLUDE_3,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_3)?.[0].value,
    },
  ],
  [
    KEY_TYPE.REVERBERATION_INFO_CONTRACT_FLAT_RATE_FLAG, {
      label: '定額制契約提案',
      operatorType: CONDITION_TYPE.EQUAL,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'false',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.EQUAL)?.[0].value,
    },
  ],
  [
    KEY_TYPE.ACCOUNTING_DATE, {
      label: '会計日',
      operatorType: CONDITION_TYPE.DATE,
      valueType: VALUE_TYPE.DATE,
      defaultOfValueType: new Date().toISOString().substring(0, 10),
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.DATE)?.[0].value,
    },
  ],
  [
    KEY_TYPE.ITEM_BUY, {
      label: '購入商品',
      operatorType: CONDITION_TYPE.INCLUDE_2,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2)?.[0].value,
    },
  ],
  [
    KEY_TYPE.COURSE_NAME, {
      label: 'コース名',
      operatorType: CONDITION_TYPE.INCLUDE_2,
      valueType: VALUE_TYPE.SELECT,
      defaultOfValueType: 'null',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.INCLUDE_2)?.[0].value,
    },
  ],
  [
    KEY_TYPE.TOTAL_NUM, {
      label: '契約回数',
      operatorType: CONDITION_TYPE.MATH,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.MATH)?.[0].value,
    },
  ],
  [
    KEY_TYPE.ACCOUNTING_AMOUNT, {
      label: '会計金額',
      operatorType: CONDITION_TYPE.MATH,
      valueType: VALUE_TYPE.TEXT,
      defaultOfValueType: '',
      defaultOfOperatorType: operatorOptions.get(CONDITION_TYPE.MATH)?.[0].value,
    },
  ],
]);
